export default [{
  path: '/takeAssent',
  name: 'takeAssent',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/takeAssent/index')
}]
